import Vue from 'vue'
import fieldGroupPropsMixin from './field-group-props-mixin'
import HintText from 'objects/hint/hint-text'

import './field-group.scss'

export default Vue.extend({
  mixins: [fieldGroupPropsMixin],
  components: { 'tt-hint-text': HintText },
  computed: {
    hint() {
      return {
        text: this.errorText || this.hintText,
        type: this.errorText ? 'error' : 'info'
      }
    }
  },
  methods: {
    getHintTextElement(createElement) {
      return createElement(HintText, {
        attrs: { id: this.describedbyId },
        props: {
          type: this.hint.type,
          text: this.hint.text
        }
      })
    },
    getLabelElement(createElement) {
      const labelChildren = [] as any
      labelChildren.push(createElement('span', {
        class: 'tt-o-field-group__label-text',
        domProps: {
          // adding a space to the label in case the required indicator follows
          innerHTML: this.label
        }
      }))
      if (this.required) {
        labelChildren.push(createElement('span', {
          class: 'tt-o-field-group__required',
          domProps: {
            innerHTML: ` ${this.$msg('fieldGroup.requiredIndicator')}`
          }
        }))
      }
      return createElement(this.asFieldset ? 'legend' : 'label', {
        attrs: { id: this.labelId, for: this.id },
        class: 'tt-o-field-group__label'
      }, labelChildren)
    }
  },
  /* This is what the html template would look like.  Converted to a render function so this
   * component could also be used for fields like checkbox groups that should use a root element
   * of "fieldset" with "legend" as a label instead of the default root element of a "div" with
   * "label".
   *
   * <div class="tt-o-field-group tt-u-spacing--xs">
   *   <label class="tt-o-field-group__label" :for="id">
   *     <span class="tt-o-field-group__label-text>{{ label }}</span>
   *     <span v-if="required" class="tt-o-field-group__required"
   *           v-html="$msg('fieldGroup.requiredIndicator')"></span>
   *   </label>
   *   <slot></slot>
   *   <tt-hint-text v-if="hint.text" :type="hint.type" :text="hint.text"></tt-hint-text>
   * </div>
   */
  render(createElement) {
    const rootChildren = []
    if (this.label) {
      rootChildren.push(this.getLabelElement(createElement))
    }
    rootChildren.push(this.$slots.default)
    if (this.hint.text) {
      rootChildren.push(this.getHintTextElement(createElement))
    }
    return createElement(
      this.asFieldset ? 'fieldset' : 'div',
      {
        attrs: {
          'aria-required': this.asFieldset && this.required ? 'true' : false,
          'aria-invalid': this.asFieldset && this.errorText ? 'true' : false
        },
        class: 'tt-o-field-group tt-u-spacing--xs'
      },
      rootChildren
    )
  }
})



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/objects/form/field-group.ts